"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Verify = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireWildcard(require("react"));
var _Localization = require("../../Localization");
var _constants = require("../../constants");
var _models = require("../../models");
var _FormValidationSummary = require("../FormValidationSummary");
var _ResendLink = require("./ResendLink");
var _VerificationCodeInput = require("./VerificationCodeInput");
var _VerificationStyledComponents = require("./VerificationStyledComponents");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Verify = props => {
  const {
    handleSubmitVerification,
    handleResendCode,
    submitErrors,
    isResendDisabled,
    awaitingRes,
    isSubmitting
  } = props;
  const codeInputRefs = (0, _react.useRef)([]);
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const invalidCodeError = submitErrors?.find(er => er.fieldName === 'ConfirmationCode');
  const mountOrUpdate = (0, _react.useCallback)(() => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- is not always truthy
    if (codeInputRefs.current && codeInputRefs.current.length > 0) {
      codeInputRefs.current[0]?.focus();
    }
  }, []);
  (0, _react.useEffect)(() => {
    mountOrUpdate();
  }, [mountOrUpdate]);
  const onNumberDelete = index => {
    const newInputIndex = index - 1;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- is not always truthy
    if (newInputIndex >= 0 && codeInputRefs.current) {
      codeInputRefs.current[newInputIndex]?.focus();
    }
  };
  const setInputRef = (instance, index) => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- is not always truthy
    if (codeInputRefs.current) {
      codeInputRefs.current[index] = instance;
    }
  };
  const submitVerification = () => {
    let codeNumbers;

    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain, @typescript-eslint/no-unnecessary-condition -- needed this condition
    if (codeInputRefs && codeInputRefs.current) {
      codeNumbers = codeInputRefs.current.map(input => input.value);
    }
    if (codeNumbers?.every(value => Boolean(value))) {
      const code = codeNumbers.join('');
      handleSubmitVerification(code);
    }
  };
  const onNumberInput = index => {
    const newInputIndex = index + 1;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- is not always truthy
    if (codeInputRefs.current && newInputIndex < codeInputRefs.current.length) {
      codeInputRefs.current[newInputIndex]?.focus();
    } else {
      submitVerification();
    }
  };
  const onPaste = event => {
    const pastedCode = event.clipboardData.getData('text/plain');
    const codeLength = codeInputRefs.current.length;
    // eslint-disable-next-line unicorn/prefer-spread -- we need split for this
    const codeArray = pastedCode.split('').slice(0, codeLength);
    codeInputRefs.current.forEach((codeInputRef, index) => {
      if (codeArray[index] && !Number.isNaN(Number(codeArray[index]))) {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion, no-param-reassign -- we need
        codeInputRef.value = codeArray[index];
      }
    });
    if (codeInputRefs.current.length) {
      submitVerification();
    }
  };
  const renderVerificationCodeInput = index => /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerificationCodeInput.VerificationCodeInput, {
    index: index,
    handleInput: onNumberInput,
    handleDelete: onNumberDelete,
    inputRef: setInputRef,
    handlePaste: onPaste,
    isError: Boolean(invalidCodeError),
    isSubmitting: isSubmitting,
    awaitingRes: awaitingRes
  }, index);
  const renderVerificationCodeInputs = () => {
    const codeLength = 6;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerificationStyledComponents.CodeDiv, {
      children: Array.from({
        length: codeLength
      }).map((_x, index) => renderVerificationCodeInput(index))
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerificationStyledComponents.RootContainer, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
      children: [renderVerificationCodeInputs(), submitErrors ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormValidationSummary.FormValidationSummary, {
        ...getTestIdProps('verification-error-summary'),
        invalidPropertyErrors: submitErrors
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_VerificationStyledComponents.ResendText, {
        paragraph: true,
        align: "center",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_VerificationStyledComponents.NoCodeText, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _constants.defaultTranslations.PhoneVerification_NoCode,
            id: _models.TranslationKey.PhoneVerification_NoCode
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ResendLink.ResendLink, {
          handleResendCode: handleResendCode,
          isResendDisabled: isResendDisabled
        })]
      })]
    })
  });
};
exports.Verify = Verify;
//# sourceMappingURL=Verify.js.map